import React from "react";
import AgentDetails from "../components/AgentDetails";

const AgentDetailsApp = (props) => <AgentDetails {...props} />;

export default AgentDetailsApp;
